import { JSX, Suspense } from "react";
import { useLocation, useOutlet } from "react-router-dom";

import GroupTransition from "@/components/helpers/GroupTransition/GroupTransition.tsx";
import Loader from "@/components/helpers/Loader.tsx";

const NestedRoutes = (): JSX.Element => {
  const outlet = useOutlet();
  const { pathname } = useLocation();

  return (
    <Suspense
      fallback={
        <div className={"flex min-h-screen items-center justify-center"}>
          <Loader />
        </div>
      }
    >
      <GroupTransition<HTMLDivElement> transitionKey={pathname}>
        {({ ref }) => <div ref={ref}>{outlet}</div>}
      </GroupTransition>
    </Suspense>
  );
};

export default NestedRoutes;
